const pmsConfigs = {
  guesty: {
    name: "Guesty",
  },
  streamline: {
    name: "Streamline",
  },
  hospitable: {
    name: "Hospitable",
    logo: "https://bellhopt-public.s3.us-west-1.amazonaws.com/hospitable.svg",
    connectSteps: {
      title: "Connect Hospitable in 3 Easy Steps",
      subtitle:
        "Get onboarded quickly, keep property and reservation data synced, and run Bellhopt logistics without manual updates.",
      steps: [
        {
          title: "1. Create your Bellhopt account",
          body: "Sign up and go to Integrations in your host dashboard.",
        },
        {
          title: "2. Click “Connect Hospitable”",
          body: "Bellhopt opens Hospitable’s secure authorization flow for a one-time connection.",
        },
        {
          title: "3. Approve access and return",
          body: "After approval, Bellhopt completes setup and starts syncing automatically.",
        },
      ],
    },
  },
  hostfully: {
    name: "Hostfully",
    logo: "/pms/hostfully.png",
    connectSteps: {
      title: "Connect Hostfully in 3 Easy Steps",
      subtitle:
        "Start from Hostfully’s Integrations page, connect Bellhopt with OAuth, then sync properties and reservations automatically.",
      steps: [
        {
          title: "1. Create or log in to Bellhopt",
          body: "Use this page’s signup/login flow so Bellhopt can attach the Hostfully connection to your host account.",
        },
        {
          title: "2. Click “Connect with Hostfully”",
          body: "From Integrations in your Bellhopt dashboard, start the secure Hostfully OAuth authorization.",
        },
        {
          title: "3. Approve access and sync",
          body: "Approve Bellhopt in Hostfully, return here, then sync properties, reservations, guest links, and entry instructions.",
        },
      ],
    },
  },
  akia: {
    name: "Akia",
  },
  hostaway: {
    name: "Hostaway",
  },
  track: {
    name: "Track",
  },
  all: {
    name: "Guesty, Streamline, and Akia",
    connectSteps: {
      title: "Connect Hospitable in 3 Easy Steps",
      subtitle:
        "Get onboarded quickly, keep property and reservation data synced, and run Bellhopt logistics without manual updates.",
      steps: [
        {
          title: "1. Create your Bellhopt account",
          body: "Sign up and go to Integrations in your host dashboard.",
        },
        {
          title: "2. Click “Connect Hospitable”",
          body: "Bellhopt opens Hospitable’s secure authorization flow for a one-time connection.",
        },
        {
          title: "3. Approve access and return",
          body: "After approval, Bellhopt completes setup and starts syncing automatically.",
        },
      ],
    },
  },
};

export default pmsConfigs;
